import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const ArrowUpIcon = ({ ariaLabel = '', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        id="Vector"
        d="M8.5 12.6666L8.5 3.33331"
        stroke="#061D33"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        id="Vector_2"
        d="M3.83341 7.99998L8.50008 3.33331L13.1667 7.99998"
        stroke="#061D33"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
